import * as React from 'react';

import { cn } from '@/lib/utils';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // Style du prototype (fond blanc, bordure slate-300) : le thème shadcn met --input à transparent, champ invisible
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-slate-300 flex h-9 w-full min-w-0 rounded-lg border px-3 py-1 text-base bg-card transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-slate-50 disabled:opacity-60 md:text-sm',
        'focus-visible:border-blue-500 focus-visible:ring-blue-500/30 focus-visible:ring-[3px]',
        'aria-invalid:ring-destructive/20 aria-invalid:border-destructive',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
